import {
  FormControl,
  VStack,
  SimpleGrid,
  GridItem,
  Text,
} from "@chakra-ui/react";
import { SelectControl, SubmitButton } from "formik-chakra-ui";
import React from "react";
import { Formik, FormikProps, Form, Field, FieldProps } from "formik";
import { updateData, UpdateParams } from "../api";
import { useMutation, useQueryClient } from "react-query";
import { useAuth } from "./AuthContext";
import { sendID3Action } from "../api";

const LowerThirdForm: React.FC<{ data: Record<string, any> }> = ({
  children,
  data,
}) => {
  const { currentLowerThirdID, channelID } = data;
  const { authInfo, isTokenExpired } = useAuth();

  const queryClient = useQueryClient();

  const updateMutation = useMutation(
    ({ filename, data, token }: UpdateParams) => {
      return updateData({ filename, data, token });
    },
    {
      onSuccess: async (response, variables) => {
        const { resetForm } = variables;
        queryClient.setQueryData(["overlayData"], response.body.updated);
        resetForm!({
          values: { lowerThird: response.body.updated.currentLowerThirdID },
        });
        try {
          await sendID3Action({
            channelID,
            actionName: "LowerThird",
            type: "LowerThird",
            action: 'Show',
            id: response.body.updated.currentLowerThirdID
          })
        } catch (err) {
          console.log('error sending id3 action: ', err)
        }
      },
    }
  );

  return (
    <Formik
      initialValues={{ lowerThird: currentLowerThirdID }}
      validateOnChange
      onSubmit={(values, actions) => {
        console.log("VALUES: ", values)
        actions.setSubmitting(true);
        try {
          const expired = isTokenExpired();
          if (!expired) {
            updateMutation.mutate({
              filename: process.env.REACT_APP_DATA_FILENAME!,
              data: [
                {
                  name: "currentLowerThirdID",
                  path: "currentLowerThirdID",
                  value: values.lowerThird,
                }
              ],
              token: authInfo.token!,
              resetForm: actions.resetForm,
            });
          } else {
            console.log("expired!");
          }
        } catch (err: any) {
          console.log(err);
        }
      }}
    >
      {(props: FormikProps<any>) => (
        <VStack w="100%" p={0} spacing={10} alignItems="flex-start">
          <Form style={{ width: "100%" }}>
            <SimpleGrid columns={2} rowGap={1} w="full" mt={2}>
              <GridItem colSpan={2}>
                <Text mt={2} align="left" fontSize="md">Current Lower Third:</Text>
              </GridItem>
              <GridItem colSpan={1} mt={2}>
                <Field name="lowerThird">
                  {({ field, form }: FieldProps) => (
                    <FormControl>
                      <SelectControl
                        name="lowerThird"
                        selectProps={{ isFullWidth: false, size: 'sm' }}>
                        {data.lowerThirds.map((lowerThird: any) => (
                          <option key={lowerThird.id} value={lowerThird.id} label={lowerThird.title} >
                            {lowerThird.title}
                          </option>
                        ))}
                      </SelectControl>
                    </FormControl>
                  )}
                </Field>
              </GridItem>
              <GridItem colSpan={1}>
                <Field name="submit">
                  {({ field, form }: FieldProps) => (
                    <>
                      <SubmitButton
                        size="sm"
                        w="30%"
                        mt={2}
                        color={"#cccccc"}
                        backgroundColor={"#233ea1"}
                        _hover={{
                          color: form.dirty ? "white" : "#cccccc",
                          backgroundColor: form.dirty && !props.isSubmitting ? "#172863" : "#233ea1",
                        }}
                        isDisabled={!form.dirty || props.isSubmitting}
                        type="submit"
                        isLoading={props.isSubmitting}
                      >
                        Update
                      </SubmitButton>
                    </>
                  )}
                </Field>
              </GridItem>
            </SimpleGrid>
          </Form>
        </VStack >
      )
      }
    </Formik >
  );
};

export default LowerThirdForm;
